
  import { QBtn, QCard, QCardActions, QCardSection, QDialog, QInput, QSelect, QToolbar } from 'quasar'
  import { email, required } from 'vuelidate/lib/validators'
  import DateFormField from '@/components/students/DateFormField.vue'

  export default {
    components: {
      DateFormField,
      QDialog,
      QBtn,
      QToolbar,
      QInput,
      QSelect,
      QCard,
      QCardSection,
      QCardActions
    },
    props: {
      student: {
        type: Object,
        default: null
      }
    },
    computed: {
      fullName () {
        return `${this.student.firstname || ''} ${this.student.middlename || ''} ${this.student.lastname || ''}`.trim()
      },
      modalButton () {
        return this.student.uh ? 'edit' : 'create'
      },
      updatedFields () {
        return Object.entries(this.student).filter(([key, value]) => this.backupStudent[key] !== value)
      }
    },
    watch: {
      translationState () {
        this.monthNames = [this.$t('months.januari.generated'),
          this.$t('months.februari.generated'),
          this.$t('months.march.generated'),
          this.$t('months.april.generated'),
          this.$t('months.may.generated'),
          this.$t('months.june.generated'),
          this.$t('months.july.generated'),
          this.$t('months.august.generated'),
          this.$t('months.september.generated'),
          this.$t('months.october.generated'),
          this.$t('months.november.generated'),
          this.$t('months.december.generated')]

        this.dayNames = [this.$t('days.sunday.generated'),
          this.$t('days.monday.generated'),
          this.$t('days.tuesday.generated'),
          this.$t('days.wednesday.generated'),
          this.$t('days.thursday.generated'),
          this.$t('days.friday.generated'),
          this.$t('days.saturday.generated')]
      }
    },
    methods: {
      hideDatePicker () {
        if (this.$refs.birthdatePicker && this.$refs.birthdatePicker.shouldShowDatepicker) {
          this.$refs.birthdatePicker.shouldShowDatepicker = false
        }
      },
      getMonthNames () {
        return [this.$t('months.januari.generated'),
          this.$t('months.februari.generated'),
          this.$t('months.march.generated'),
          this.$t('months.april.generated'),
          this.$t('months.may.generated'),
          this.$t('months.june.generated'),
          this.$t('months.july.generated'),
          this.$t('months.august.generated'),
          this.$t('months.september.generated'),
          this.$t('months.october.generated'),
          this.$t('months.november.generated'),
          this.$t('months.december.generated')]
      },
      getDayNames () {
        return [this.$t('days.sunday.generated'),
          this.$t('days.monday.generated'),
          this.$t('days.tuesday.generated'),
          this.$t('days.wednesday.generated'),
          this.$t('days.thursday.generated'),
          this.$t('days.friday.generated'),
          this.$t('days.saturday.generated')]
      },
      importSubject () {
        this.$refs.importmodal.show()
      },
      modalBack () {
        this.$refs.modal.hide()
        this.$emit('cancel')

        this.$v.$reset()
      },
      open () {
        this.$v.$reset()
        this.$nextTick(() => {
          this.backupStudent = Object.assign({}, this.student)
          this.innerValue = JSON.parse(JSON.stringify(this.student))

          this.$refs.modal.show()
        })
      },
      close () {
        this.$refs.modal.hide()
      },
      resetValues () {
        this.hideDatePicker()
        this.buttonLoader = false
      },
      submit () {
        this.buttonLoader = true
        this.$emit('submit', { student: this.student, updatedFields: this.updatedFields })
      }
    },
    validations: {
      student: {
        firstname: { required },
        lastname: { required },
        email: {
          required,
          email
        }
      }
    },
    data () {
      return {
        innerValue: null,
        showModal: false,
        monthNames: this.getMonthNames(),
        dayNames: this.getDayNames(),
        translationState: this.$getTranslationOptions(),
        buttonLoader: false,
        date: new Date(),
        backupStudent: {},
        statusOptions: [
          {
            label: 'Actief',
            value: 'active'
          },
          {
            label: 'Inactief',
            value: 'inactive'
          }
        ]
      }
    }
  }
